import vasActivationModalTemplate from '../../../components/services/activations/vasActivationInstruction.modal.html';
import angular from 'angular';

class SidenavController {
  /* @ngInject */
  constructor($log, $q, $rootScope, $location, $timeout, StoreService, MerchantVasService, Dispatcher, StorageService, NewTokenService, ModalFactory) {
    const that = this;
    that.showSubmenu;
    that.showMenu = true 
    that.selectedStore = undefined;

    /*const isSuperAdmin = () => {
      const userContext = NewTokenService.getUserContext();
      this.isSuperAdmin = userContext !== undefined ? userContext.superAdmin : false;
    };*/
    
    const isSuperAdmin = () => {
      this.isSuperAdmin = StorageService.getLocalStorage('superAdmin');
    };

    const resetItems = () => {
      that.items = {
        messageOutbound: false,
        taxation: false,
        checkin: false,
        menu: false,
        services: false
      };
    };

    /*const loadSettings = () => {
      resetItems();
      isSuperAdmin();
      MerchantConfigurationService.getMerchantStoreConfiguration().then((settings) => {
        that.items.menu = settings.isVasMerchant && settings.services.orderAndPay;
        that.items.taxation = settings.services.invoices;
        that.items.messageOutbound = settings.isVasMerchant && settings.services.messageOutbound;
      }, (reason) => {
        $log.error('SidenavController', 'loadSettings', reason);
      });
    };*/

    const loadSettings = () => {
      var storeId;
      resetItems();
      isSuperAdmin();
      var merchantProfile = angular.fromJson(StorageService.getLocalStorage('userContext'));
      if (!merchantProfile) return;
      MerchantVasService.getVasesForCurrent(merchantProfile.business.id).then( res => {
        if(res.data._embedded){
          var vasses = res.data._embedded.vasses;
          vasses.filter( vas => {
            if(vas.vasTypeId == 2 && vas.status == "SUBSCRIBED")
              that.items.messageOutbound = true; 
          })
        }
      }, (reason) => {
        $log.error('SidenavController', 'loadSettings', reason);
      });
    };



    const init = () => {
      that.selectedStore = undefined;
      that.showSubmenu = true;
      
      that.isLogged = NewTokenService.isLogged();
      if(StoreService.getSelectedStore())
        that.selectedStore = StoreService.getSelectedStore().option
      else{
        if(StoreService.getSavedStoreList().length > 0){
          var store = StoreService.getSavedStoreList()[0]
        that.selectedStore = store.name +", "+store.address
        }else{
          that.selectedStore = "";
        }
        
      }
      
      loadSettings();
    };

    that.$onInit = init;

    Dispatcher.register(function(action) {
      if(action.actionType == "GLOBAL_CLEAN"){
        that.selectedStore = ""
      }
    })

    const deregStoreChanged = $rootScope.$on("$storeChangeSuccess", () => {
      if(StoreService.getSelectedStore()){
        that.selectedStore = StoreService.getSelectedStore().option
      }else{
        if(StoreService.getSavedStoreList().length > 0){
          var store = StoreService.getSavedStoreList()[0]
          that.selectedStore = store.name +", "+store.address
        }else{
          that.selectedStore = ""
        }
      }
      loadSettings();
    })

    const deregToogleSidenav = $rootScope.$on('TOOGLE_SIDENAV', (evt, data) => {
      that.showMenu = document.getElementById('sidenav').className.includes("is-active-add") ? true : false;
      console.log(that.showMenu)
    })
    const deregStoreConfigUpdateListener = $rootScope.$on('STORECONFIG_UPDATE', loadSettings);
    const deregLoginListener = $rootScope.$on('USER_LOGGED_IN', init);
    const deregSuperLoginListener = $rootScope.$on('SUPER_ADMIN_LOGGED_IN', () => {that.isLogged = true});
    const deregLogoutListener = $rootScope.$on('USER_LOGGED_OUT', () => {
      that.isLogged = false;
      resetItems();
    });

    const deregStateChangedListener = $rootScope.$on('$stateChangeSuccess',  function (event, data) {
      that.showSubmenu = true;
    });

    $rootScope.$on("GOT-VASSES",(event, arg) =>{
      resetItems();
      if(arg.success && arg.returned.data['_embedded']){
        angular.forEach(arg.returned.data['_embedded'].vasses, (element)=>{

          switch (element.name){

            case 'OUTBOUND-MESSAGES':
                if(element.status === "SUBSCRIBED") {
                  that.items.messageOutbound = true;
                } else {
                  that.items.messageOutbound = false;
                }
              break;
            case 'ORDER-AND-PICK':
              if(element.status === "SUBSCRIBED");
              break;
            case 'ORDER-AND-DELIVERY':
              if(element.status === "SUBSCRIBED");
              break;
            case 'OFFICE-DELIVERY':
                if(element.status === "SUBSCRIBED");
                break;
            case 'ORDER-AT-TABLE':
              if(element.status === "SUBSCRIBED");
              break;
            case 'BILL-AT-TABLE':
              if(element.status === "SUBSCRIBED");
              break;
            case 'INVOICES':
              if(element.status === "SUBSCRIBED") {
                that.items.taxation = true;
              } else {
                that.items.taxation = false;
              }
              break;
            case 'CORPORATE-CASH':
              if(element.status === "SUBSCRIBED");
              break;
            case 'PAY-WITH-ALIPAY':
              if(element.status === "SUBSCRIBED");
              break;
            case 'PROJECT-WITH-ALIPAY':
              if(element.status === "SUBSCRIBED");
              break;
            case 'MOBILE-PAY-WITH-ALIPAY':
              if(element.status === "SUBSCRIBED");
              break;


          }

        });

      }

    });

    this.navigateToMessageOutbound = () => {
      if(that.items.messageOutbound){
        $location.path("/message/new")
      }else{
        this.showVasActivationModal();
      }
    }

    this.showVasActivationModal = () => {
      const closeModal = () => {
          modal.deactivate();
          $timeout(modal.destroy, 1000);
      };

      const modal = new ModalFactory({
          overlay: true,
          overlayClose: true,
          template: vasActivationModalTemplate,
          class: 'default',
          contentScope: {
              okFunc: closeModal,
              attempt : "enable"
          }
      });

      modal.activate();
  };


    that.$onDestroy = () => {
      deregStoreChanged();
      deregStoreConfigUpdateListener();
      deregLoginListener();
      deregLogoutListener();
      deregStateChangedListener();
      deregStateChangedListener();
    };
  }
}

export default SidenavController;



/** WEBPACK FOOTER **
 ** ./client/app/common/components/sidenav/sidenav.controller.js
 **/